import { D as DEVICE_TYPES } from './deviceTypes-wW4MAd2m.js';

/**
 * Take the name of a size and get its value from the theme
 *
 * @param  {Object}            theme        Storm theme object
 * @param  {String | Number}   size         The name or value of a size
 * @param  {String}            deviceType   Whether to get the mobile padding or not
 * @return {Number}                         Size in pixels of the padding
 */
function getPadding(theme, size = 'xlarge', deviceType = DEVICE_TYPES.DESKTOP) {
  // IN the case we are given a number, just return it
  if (typeof size === 'number') {
    return size;
  }
  if (deviceType === DEVICE_TYPES.MOBILE) {
    if (theme && theme.mobile && theme.mobile.spacingValues && typeof theme.mobile.spacingValues[size] !== 'undefined') {
      return theme.mobile.spacingValues[size];
    }
  }
  if (theme && theme.spacingValues && typeof theme.spacingValues[size] !== 'undefined') {
    return theme.spacingValues[size];
  }
  return 0;
}

export { getPadding as g };
//# sourceMappingURL=getPadding-Bvzhcf_u.js.map
